
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Pourquoi créer un blog d’entreprise ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Cet article vous présente les bénéfices d’un blog d’entreprise et vous explique comment créer le vôtre.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Pourquoi créer un blog d’entreprise ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Cet article vous présente les bénéfices d’un blog d’entreprise et vous explique comment créer le vôtre.",
        },
      ],
    };
  },
};
